import React, { useEffect, useRef, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import SettingsSharpIcon from "@mui/icons-material/SettingsSharp";
import { IoIosArrowDown } from "react-icons/io";
import { useTranslation } from "react-i18next";

const Settings = () => {
  const loginType = localStorage.getItem("loginType");
  const usernameTag = localStorage.getItem("user-nameTag");
  const [isSecurityOpen, setIsSecurityOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsSecurityOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div ref={dropdownRef} className="row py-2 mt-2 BothSec">
        <div className="col-md-12 col-12 col-lg-4 BothSecfirst">
          <div className="settingSidebar p-4">
            <div className="username d-flex flex-wrap">
              <SettingsSharpIcon className="material-symbols-sharp settingIcon" />
              <div className="ms-3">
                <p className="f-14 mb-0">{usernameTag}</p>
                <span className="f-12 innerHeading">{t("Notifications.Settings")}</span>
              </div>
            </div>
            <ul>
              <NavLink to="profile">
                <li
                  className={`navLinks ${
                    location.pathname.includes("/profile") ? "active" : ""
                  }`}
                >
                  <span>{t("Notifications.Profile")}</span>
                </li>
              </NavLink>

              {/* {loginType === "Email" && (
                <NavLink to="changePassword">
                  <li
                    className={`navLinks ${
                      location.pathname.includes("/changePassword")
                        ? "active"
                        : ""
                    }`}
                  >
                    <span>{t("User Profile.Change Password")}</span>
                  </li>
                </NavLink>
              )} */}

             <NavLink to="pageNotification">
                <li
                  className={`navLinks ${
                    location.pathname.includes("/pageNotification")
                      ? "active"
                      : ""
                  }`}
                >
                  <span>{t("Notifications.Notification")}</span>
                </li>
              </NavLink>

              <NavLink to="blockedUser">
                <li
                  className={`navLinks ${
                    location.pathname.includes("/blockedUser") ? "active" : ""
                  }`}
                >
                  <span>{t("User Profile.Manage Blocked Users")}</span>
                </li>
              </NavLink>
              <NavLink to="blockedCompany">
                <li
                  className={`navLinks ${
                    location.pathname.includes("/blockedCompany") ? "active" : ""
                  }`}
                >
                  <span>{t("User Profile.Manage Blocked Companies")}</span>
                </li>
              </NavLink>
              
              <li
                onClick={() => setIsSecurityOpen(!isSecurityOpen)}
                className={`navLinks pointer d-flex justify-content-between ${
                  isSecurityOpen ||
                  location.pathname.includes("privacy") ||
                  location.pathname.includes("manageSessions") ||
                  location.pathname.includes("2fAuth") ||
                  location.pathname.includes("changeEmailAddress")
                    ? "securityactive"
                    : ""
                }`}
              >
                <span>{t("User Profile.Security")}</span>
                <IoIosArrowDown className="dropdownIcon" />
              </li>

              {isSecurityOpen && (
                <ul className="dr">
                  <NavLink to="privacy">
                    <li
                      className={`navLinks ${
                        location.pathname.includes("/privacy") ? "active" : ""
                      }`}
                    >
                      <span>Privacy</span>
                    </li>
                  </NavLink>
                  <NavLink to="changePassword">
                    <li
                      className={`navLinks ${
                        location.pathname.includes("/changePassword")
                          ? "active"
                          : ""
                      }`}
                    >
                      <span>{t("SignIn.Password")}</span>
                    </li>
                  </NavLink>
                  <NavLink to="manageSessions">
                    <li
                      className={`navLinks ${
                        location.pathname.includes("/manageSessions")
                          ? "active"
                          : ""
                      }`}
                    >
                      <span>{t("User Profile.Manage Sessions")}</span>
                    </li>
                  </NavLink>
                  <NavLink to="2fAuth">
                    <li
                      className={`navLinks ${
                        location.pathname.includes("/2fAuth") ? "active" : ""
                      }`}
                    >
                      <span>{t("User Profile.2F - Auth")}</span>
                    </li>
                  </NavLink>
                  <NavLink to="changeEmailAddress">
                    <li
                      className={`navLinks ${
                        location.pathname.includes("/changeEmailAddress")
                          ? "active"
                          : ""
                      }`}
                    >
                      <span>{t("User Profile.Change Email Address")}</span>
                    </li>
                  </NavLink>
                </ul>
              )}

              <NavLink to="account">
                <li
                  className={`navLinks ${
                    location.pathname.includes("/account") ? "active" : ""
                  }`} >
                  <span>{t("User Profile.Account")}</span>
                </li>
              </NavLink>
            </ul>
          </div>
        </div>
        <div className="col-md-12 col-12 col-lg-8 BothSecSecond">
          <div className="settingSidebar">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
